import { gql } from '@apollo/client'

export const UPSERT_THEATRICAL_USER_PREFERENCES = gql`
  mutation UpsertTheatricalUserPreferences($input: UserPreferenceInput!) {
    upsertTheatricalUserPreferences(input: $input) {
      id
      autobookEnabled
      timezone
      phoneNumber
      theaterPreferences {
        id
        priority
      }
      dayPreferences {
        day
        timeRanges {
          start
          end
        }
      }
      preferredVenues {
        id
        name
        providerId
        vendorLogo {
          cloudinaryPath
        }
        phone
        addressText
        address {
          line
          city
          countryCode
          zipCode
        }
      }
    }
  }
`
